import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../Card';
import { Badge } from '../Badge';
import { Activity, Sparkles, TrendingUp, TrendingDown } from 'lucide-react';
const parameters = [{
  id: 'pol',
  name: 'Political Stability',
  value: 82,
  inverse: false,
  delta: '+2.1%',
  trend: 'up',
  color: 'bg-emerald-500'
}, {
  id: 'eco',
  name: 'Economic Anxiety',
  value: 61,
  inverse: true,
  delta: '+4.5%',
  trend: 'up',
  color: 'bg-amber-500'
}, {
  id: 'soc',
  name: 'Social Cohesion',
  value: 73,
  inverse: false,
  delta: '-1.2%',
  trend: 'down',
  color: 'bg-primary'
}, {
  id: 'trust',
  name: 'National Trust',
  value: 66,
  inverse: false,
  delta: '+0.5%',
  trend: 'up',
  color: 'bg-primary'
}, {
  id: 'threat',
  name: 'Threat Activity',
  value: 47,
  inverse: true,
  delta: '+12.4%',
  trend: 'up',
  color: 'bg-orange-500'
}];
export function PresidentialStabilityIndex() {
  return <Card className="bg-card border-border/50 h-full flex flex-col min-h-[400px]" data-id="element-799">
      <CardHeader className="pb-4 pt-5 px-5 border-b border-border/50 bg-muted/10" data-id="element-800">
        <div className="flex items-start justify-between gap-4" data-id="element-801">
          <div data-id="element-802">
            <CardTitle className="font-mono text-sm uppercase tracking-wider text-foreground flex items-center gap-2" data-id="element-803">
              <Activity className="size-4 text-primary" data-id="element-804" />
              Presidential Stability Index
            </CardTitle>
            <div className="mt-3 flex items-end gap-3" data-id="element-805">
              <span className="text-4xl font-bold font-mono leading-none text-foreground" data-id="element-806">
                71
              </span>
              <div className="flex flex-col pb-0.5" data-id="element-807">
                <span className="font-mono text-[10px] text-muted-foreground" data-id="element-808">
                  / 100
                </span>
                <span className="text-xs font-bold text-primary uppercase tracking-wide" data-id="element-809">
                  Stabil Terkendali
                </span>
              </div>
            </div>
          </div>
          <Badge variant="outline" className="font-mono text-[10px] h-6 border-emerald-500/30 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 flex items-center gap-1" data-id="element-810">
            <TrendingUp className="size-3" data-id="element-811" />
            +2.4 vs Kemarin
          </Badge>
        </div>
      </CardHeader>

      <CardContent className="p-5 flex-1 flex flex-col justify-between gap-6" data-id="element-812">
        {/* Progress Rows */}
        <div className="space-y-4" data-id="element-813">
          {parameters.map(param => <div key={param.id} className="flex flex-col gap-1.5" data-id="element-814">
              <div className="flex items-center justify-between" data-id="element-815">
                <span className="text-xs font-medium text-foreground" data-id="element-816">
                  {param.name}
                </span>
                <div className="flex items-center gap-3" data-id="element-817">
                  <span className="font-mono text-xs font-bold text-foreground" data-id="element-818">
                    {param.value}
                  </span>
                  <div className="flex items-center gap-1 w-12 justify-end" data-id="element-819">
                    {param.trend === 'up' ? <TrendingUp className={`size-3 ${param.inverse ? 'text-red-500' : 'text-emerald-500'}`} data-id="element-820" /> : <TrendingDown className={`size-3 ${param.inverse ? 'text-emerald-500' : 'text-red-500'}`} data-id="element-821" />}
                    <span className={`font-mono text-[9px] ${param.inverse ? param.trend === 'up' ? 'text-red-500' : 'text-emerald-500' : param.trend === 'up' ? 'text-emerald-500' : 'text-red-500'}`} data-id="element-822">
                      {param.delta}
                    </span>
                  </div>
                </div>
              </div>
              <div className="h-2 w-full bg-muted rounded-full overflow-hidden" data-id="element-823">
                <div className={`h-full rounded-full ${param.color}`} style={{
              width: `${param.value}%`
            }} data-id="element-824" />
              </div>
            </div>)}
        </div>

        {/* AI Callout */}
        <div className="bg-primary/5 border border-primary/20 rounded-md p-3.5 relative overflow-hidden mt-auto" data-id="element-825">
          <div className="absolute -right-2 -top-2 text-primary/10" data-id="element-826">
            <Sparkles className="size-12" data-id="element-827" />
          </div>
          <div className="flex items-start gap-2.5 relative z-10" data-id="element-828">
            <Sparkles className="size-4 text-primary shrink-0 mt-0.5" data-id="element-829" />
            <div data-id="element-830">
              <p className="font-mono text-[10px] font-bold text-primary uppercase tracking-wider mb-1" data-id="element-831">
                Interpretasi Strategis
              </p>
              <p className="text-xs italic text-foreground/80 leading-relaxed" data-id="element-832">
                Indeks stabilitas dalam zona terkendali. Kekhawatiran ekonomi
                mulai menekan kohesi sosial. Rekomendasi: prioritaskan
                komunikasi BBM dan harga pangan dalam 48 jam.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-2 border-t border-border/50" data-id="element-833">
          <span className="font-mono text-[9px] text-muted-foreground" data-id="element-834">
            Diperbarui setiap 15 menit · 14:32 WIB
          </span>
          <span className="font-mono text-[9px] text-muted-foreground" data-id="element-835">
            AI Composite Model v3.1
          </span>
        </div>
      </CardContent>
    </Card>;
}